import React, { useEffect, useState } from "react";
import "./SettingsPage.css";
import {
  Box,
  CircularProgress,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import colors from "../../../../Constants/colors";
import Usage from "../RetrievalBot/Usage/Usage";
import PricingPage from "../../PricingPage/PricingPage";
import GenerateApiKeys from "../GenerateApiKeys/GenerateApiKeys";
import MyKeys from "../MyKeys/MyKeys";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Sync } from "@mui/icons-material";
import { settingsPageStyles } from "./SettingsPageStyles";
import {
  get_organization_by_user,
  get_usage,
} from "../../../../features/organization/orgSlice";
import VerificationToken from "./VerificationToken";
import ModelSelectionPage from "../LLMSelectorEval/LLMSelectorEval";
import { tabsStyle } from "../../../../Constants/theme";

const tabMap = [
  { label: "External Keys", value: "0", path: "myKeys" },
  { label: "Usage", value: "1", path: "usage" },
  { label: "Subscription", value: "2", path: "subscription" },
  { label: "Queryloop Keys", value: "3", path: "apiKeys" },
  { label: "Verification Token", value: "4", path: "verificationToken" },
  { label: "Model Selection", value: "5", path: "select-llm" },
];

const SettingsPage = ({ userId, showSnackbar }) => {
  const [value, setValue] = useState("0");
  const [reloadLoading, setReloadLoading] = useState(false);
  const { user, usage } = useSelector((state) => state.auth);
  const organization = useSelector((state) => state.organization);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("valueIndex"));
    if (storedValue === 2 || storedValue === 3) {
      setValue(String(storedValue));
      localStorage.setItem("valueIndex", 0);
    }
  }, []);

  useEffect(() => {
    if (
      !(user?.user?.privilege === "owner" || user?.user?.privilege === "admin")
    ) {
      navigate("deployedBots/");
    }
    const urlPart =
      window.location.href.split("/").pop() ||
      window.location.href.split("/").slice(-2)[0];
    const matched = tabMap.find((tab) => tab.path === urlPart);
    if (matched) setValue(matched.value);
  }, [window.location.href]);

  const handleSettingsReload = async () => {
    setReloadLoading(true);
    try {
      if (value === "1") {
        const org_id = organization?.organization?._id?.["$oid"];
        const usage_id = organization?.organization?.usage?.[0]?.["$oid"];
        if (usage_id && Object.keys(organization?.usage)?.length === 0) {
          await dispatch(get_usage({ org_id, usage_id })).unwrap();
        }
      } else {
        const id = user?.user?._id["$oid"];
        if (id) await dispatch(get_organization_by_user(id)).unwrap();
      }
    } catch (error) {
      console.error("Error in handleSettingsReload:", error);
    } finally {
      setReloadLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const path = tabMap.find((tab) => tab.value === newValue)?.path;
    if (path) navigate(`settingsPage/${path}`);
  };

  return (
    <Box sx={settingsPageStyles}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ backgroundColor: colors.extremeBlue, py: 1, px: 2 }}
      >
        <Tabs value={value} onChange={handleChange} sx={tabsStyle}>
          {tabMap.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        <Tooltip
          title={
            organization?.organization
              ? "Refresh Settings"
              : "Loading Organization, Please wait."
          }
        >
          <span>
            <IconButton
              onClick={handleSettingsReload}
              disabled={!organization?.organization || reloadLoading}
              sx={{
                color: colors.extremeWhite,
                bgcolor: colors.primaryBlue,
                ":hover": { bgcolor: colors.secondaryBlue },
                "&.Mui-disabled": {
                  color: colors.lightGray,
                  bgcolor: colors.secondaryBlue,
                },
                width: 40,
                height: 40,
                borderRadius: 2,
              }}
            >
              {reloadLoading ? <CircularProgress size={24} /> : <Sync />}
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      {/* Tab Content */}
      {value === "0" && <MyKeys userId={userId} />}
      {value === "1" && <Usage userId={userId} usage={usage} />}
      {value === "2" && <PricingPage userId={userId} setValue={setValue} />}
      {value === "3" && <GenerateApiKeys userId={userId} setValue={setValue} />}
      {value === "4" && <VerificationToken />}
      {value === "5" && <ModelSelectionPage showSnackbar={showSnackbar} />}
    </Box>
  );
};

export default SettingsPage;
